<template>
  <div class="file-card shadow-1">

    <a v-if="isFile" :href="filePath" target="_blank" :title="getFileName()">
      <div class="file-preview">
        <i :class="fileIcon"/>
      </div>
      <div class="file-description">
        <small>{{ getFileName() }}</small>
      </div>
    </a>

    <template v-else-if="isImage">
      <div class="file-preview">
        <Image alt="" :src="filePath" preview />
      </div>
      <div class="file-description">
        <small>{{ getFileName() }}</small>
      </div>
    </template>

    <template v-else-if="isVideo">
      <div class="file-preview">
        <video controls>
          <source :src="filePath" type="video/mp4">
        </video>
      </div>
      <div class="file-description">
        <small>{{ getFileName() }}</small>
      </div>
    </template>

    <i v-if="showRemove" class="fa fa-trash-o" @click="removeFile"/>
  </div>
</template>

<script>
export default {
  name: "FileCard",
  props: {
    fileUrl: {
      required: true
    },
    showRemove: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    filePath() {
      if (typeof this.fileUrl === 'string') {
        return this.fileUrl
      } else if (typeof this.fileUrl === 'object') {
        for (let key in this.fileUrl) {
          if (/^http/.test(this.fileUrl[key])) {
            return this.fileUrl[key]
          }
        }
        return this.fileUrl
      } else {
        return this.fileUrl
      }
    },
    isImage() {
      return /\.(png|jpg|jpeg|gif|svg)$/gi.test(this.filePath);
    },
    isVideo() {
      return /\.(mp4)$/gi.test(this.filePath);
    },
    isFile() {
      return !this.isImage && !this.isVideo;
    },
    fileIcon(){
      let icon = 'fa fa-file-o';
      if(this.isImage){
        icon = 'fa fa-file-image-o';
      }else if(this.isVideo){
        icon = 'fa fa-file-video-o';
      }else if(this.isFile){
        if(/\.(pdf)$/gi.test(this.filePath)){
          icon = 'fa fa-file-pdf-o';
        }else if(/\.(doc|docx)$/gi.test(this.filePath)){
          icon = 'fa fa-file-word-o';
        }else if(/\.(xls|xslx)$/gi.test(this.filePath)){
          icon = 'fa fa-file-excel-o';
        }
      }
      return icon;
    }
  },
  methods: {
    getFileName() {
      return this.fileUrl.name ? this.fileUrl.name : String(this.filePath || '').split("/").pop();
    },
    removeFile() {
      this.$emit('remove', this.fileUrl)
    }
  }
}
</script>

<style scoped lang="scss">
video{
  width: 100%;
  height: 100%;
}
.file-card {
  position: relative;
  border-radius: 5px;
  overflow: hidden;

  a {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: #333;
  }

  .file-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
    font-size: 50px;
    overflow: hidden;
  }

  .file-description {
    padding: 15px;

    small {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      min-height: 30px;
      text-align: center;
    }
  }

  :deep(img) {
    max-width: 100%;
    width: 100%;
    height: auto;
    margin: auto;
    min-width: 40px;
  }

  i.fa-trash-o {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
    color: #ff0000;
    font-size: larger;
  }
}
</style>
